import { get, post } from "../../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getFolderHeader = (documentId, siteId) => get(`${url}/leasingfolders/${documentId}/${siteId}/header`);

const loadFolderWarnings = (documentId, siteId) => get(`${url}/leasingfolders/${documentId}/${siteId}/warnings`);
const loadFolderReports = (documentId, siteId) => post(`${url}/reports/document-reports`, { documentId, siteId });

const exp = {
  getFolderHeader,
  loadFolderWarnings,
  loadFolderReports
};
export default exp;
